import React from 'react';
import MenuSection from './components/MenuSection';
import menuSections from './menuConfig';
import getMenuSectionsForCompany from './menuAccess';

const MenuListMobile = ({ companyId, companyName }) => {
    const info = JSON.parse(sessionStorage.getItem("userDetails"));
    const companyKey = companyId ?? companyName ?? info?.companyId ?? info?.companyName;

    const sections = companyKey ? getMenuSectionsForCompany(companyKey) : menuSections;

    return (
        <div className="min-h-screen w-full bg-gradient-to-b from-customSlate via-white to-customSky dark:from-customSurface dark:via-customSurface dark:to-customSurfaceMuted">
            <div className="mx-auto flex w-full max-w-5xl flex-col gap-6 px-4 pb-16 pt-6 sm:px-6">
                <header className="rounded-3xl border border-customAccent/20 bg-white/90 p-5 shadow-xl shadow-customAccent/10 backdrop-blur dark:border-customSurface dark:bg-customSurface">
                    <div className="flex flex-col gap-3">
                        <span className="inline-flex w-max items-center gap-2 rounded-full bg-customAccentBlue/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-customAccentBlue dark:bg-customAccent/20 dark:text-customHeading">
                            Personalized shortcuts
                        </span>
                        <h1 className="text-xl font-semibold text-customInk dark:text-customHeading">
                            Explore your menu hub
                        </h1>
                        <p className="text-sm text-customSecondaryText dark:text-customMuted">
                            Quick actions are coming soon - meanwhile, jump into the tools you use every day, organized by workflow.
                        </p>
                    </div>
                </header>

                <div className="flex flex-col gap-4">
                    {sections.map((section, index) => (
                        <MenuSection
                            key={section.id ?? section.title}
                            title={section.title}
                            gridClass={section.gridClass}
                            items={section.items}
                            index={index}
                            total={sections.length}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default MenuListMobile;

